module.exports = __webpack_public_path__ + "static/img/98-1.ca5263c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/98-1.jpg
// module id = XCng
// module chunks = 0